<template>
    <div id="FooterSection">
        <section id="footer-sitemap">
            <div class="sitemap-container w3 w80-mb lh18">
                <div class="sitemap-group" v-for="(item, index) of navItems" :key="'sitemap-group-' + index">
                    <h3 class="f16 f14-mb bold">{{ item.title }}</h3>
                    <p v-for="subitem of item.items" :key="subitem.title" class="f14 f12-mb">
                        <router-link :to="subitem.routeUrl" tabindex="0" role="button">{{ subitem.title }}</router-link>
                    </p>
                </div>
            </div>
        </section>
        <section id="footer-address">
            <address class="footer-address-container f14 f12-mb lh15 w3 w80-mb">
                <div class="footer-address-left">
                    <img :src="require('@/assets/png/horizontal-logo.png')" alt="環境部資源循環署完整LOGO" />
                    <h3 class="bold">環境部資源循環署 版權所有</h3>
                    <div class="address-wrap">
                        <p>
                            (02)-23705888<br />
                            {{ '100005 臺北市中正區衡陽路99號13樓' }}
                        </p>
                        <a class="medium f12" tabindex="0" role="button" target="_blank" href="https://recycle.moenv.gov.tw/Introduction/ContactInfo"
                            ><i class="icon-map"></i>交通地圖</a
                        >
                    </div>
                </div>
                <div class="footer-address-right">
                    <span class="bold">
                        海洋廢棄物循環產品標章諮詢窗口 <br />
                        毅泰管理顧問股份有限公司：(02)2953-3590
                    </span>
                    <span class="bold">資源回收專線：0800-085-717</span>
                    <div class="social-media-group">
                        <a tabindex="0" role="button" target="_blank" href="https://r-paper.moenv.gov.tw/index.aspx"
                            ><i class="icon-newspaper"></i><span style="display: none">回收綠報報</span></a
                        >

                        <a tabindex="0" role="button" target="_blank" href="https://www.facebook.com/MOENR.TW/"
                            ><i class="icon-facebook"></i><span style="display: none">Facebook</span></a
                        >
                    </div>
                </div>
            </address>
        </section>
        <section id="footer-links-counts">
            <div class="footer-links-counts-container f14 f12-mb w1 w90-mb">
                <div class="footer-links">
                    <a tabindex="0" role="button" v-for="item of links" :key="item.title" :href="item.href" target="_blank">{{ item.title }}</a>
                </div>
                <div class="footer-counts">
                    <span>今日瀏覽人數：{{ todayViewCount.toLocaleString('en-US') }}</span>
                    <span>累積瀏覽人數：{{ totalViewCount.toLocaleString('en-US') }}</span>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'FooterSection',
}
</script>
<script setup>
import { ref } from 'vue'
import { getConfigCount } from '@/service/apis'
import getNavItems from '@/data/getNavItems.js'
const { navItems } = getNavItems()
const links = [
    {
        title: '隱私權保護政策',
        href: 'https://www.moenv.gov.tw/Page/E6525EED58F263A3',
    },
    {
        title: '網站安全政策',
        href: 'https://www.moenv.gov.tw/Page/285410B281867E93',
    },
    {
        title: '網站資料開放宣告',
        href: 'https://www.moenv.gov.tw/Page/7CED63B63DB9E5DF',
    },
    {
        title: '意見信箱',
        href: 'https://epamail.moenv.gov.tw/front/mailboxhome',
    },
]
const todayViewCount = ref(0)
const totalViewCount = ref(0)
async function initCount() {
    let res = await getConfigCount()
    todayViewCount.value = res.todayViewCount
    totalViewCount.value = res.totalViewCount
}
initCount()
</script>
<style lang="scss" scoped>
$address-color: #324671;
$links-counts-color: #70809c;

#footer-sitemap {
    color: $gray6;
    background-color: $grayF;
    padding: 40px 0;

    @media screen and (min-width: 768px) {
        .sitemap-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
    @media screen and (max-width: 767px) {
        .sitemap-container {
            display: grid;
            grid-template: auto / repeat(2, 1fr);
            grid-gap: 30px;
        }
    }
}
#footer-address {
    color: $theme0;
    background-color: $address-color;
    .footer-address-container {
        padding: 50px 0;
    }
    img {
        display: block;
        width: 150px;
        height: 150px;
    }

    .footer-address-left {
        display: flex;
        flex-direction: column;
        img {
            margin-bottom: 1.5em;
        }
        h3 {
            margin-bottom: 1em;
        }
        a {
            display: inline-block;
            margin-top: 10px;
            margin-left: 10px;

            padding: 5px 10px;
            border-radius: 30px;
            color: $address-color;
            background-color: $theme0;
            transition: 0.3s;
            i.icon-map {
                position: relative;
                top: 2px;
                margin-right: 3px;
            }

            &:hover,
            &:focus {
                color: lighten($address-color, 10%);
                background-color: lighten($theme0, 10%);
            }
        }
    }
    .footer-address-right {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        gap: 4px;
        span {
            display: inline-block;
            padding: 10px;
            border-radius: 10px;
            border: 2px solid $theme0;
        }
        .social-media-group {
            margin-top: 8px;
            a {
                margin-left: 8px;
                color: $theme0;
                font-size: 32px;
                transition: 0.3s;
                &:hover,
                &:focus {
                    color: lighten($theme0, 10%);
                }
            }
        }
    }

    @media screen and (min-width: 1120px) {
        .address-wrap {
            display: flex;
        }
        .social-media-group {
            text-align: right;
        }
    }
    @media screen and (max-width: 1119px) {
        .footer-address-right {
            margin-top: 20px;
            width: fit-content;
        }
    }
    @media screen and (min-width: 768px) {
        address {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
}
#footer-links-counts {
    padding: 20px 0;
    color: $white;
    background-color: $links-counts-color;

    .footer-links {
        a {
            border-right: 1px solid $white;
            &:last-child {
                border-right: none;
            }
        }
    }
    div {
        span,
        a {
            display: inline-block;
            padding: 0 1em;
            line-height: 1em;
        }
    }

    @media screen and (min-width: 768px) {
        .footer-links-counts-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
    @media screen and (max-width: 767px) {
    }
}
</style>
